import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Users, ShieldCheck, Zap } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?crop=entropy&cs=srgb&fm=jpg&q=85";
const CARD1 = "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?crop=entropy&cs=srgb&fm=jpg&q=85";
const CARD2 = "https://images.unsplash.com/photo-1519440862171-af26cf8c2a85?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function Home() {
  return (
    <div>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img src={HERO} alt="detail" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B0E]/60 via-[#0A0B0E]/85 to-[#0A0B0E]" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-28 lg:pb-32">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#CCFF00]/40 bg-[#CCFF00]/10 px-3 py-1 text-xs uppercase tracking-widest text-[#CCFF00]">
              <Sparkles size={12} /> Mobile Auto Detailing
            </div>
            <h1 className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl leading-none">
              CLEAN CARS.<br/>
              <span className="text-[#CCFF00]">STRONG COMMUNITY.</span><br/>
              BETTER FUTURE.
            </h1>
            <p className="mt-6 text-lg text-zinc-300 max-w-xl">
              Premium mobile detailing that comes to you. Book in minutes, pay a small
              deposit, and let our team make your ride shine — right in your driveway.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link to="/book" data-testid="hero-book-btn" className="neon-btn px-6 py-4 rounded-xl inline-flex items-center gap-2">
                Request a Detail <ArrowRight size={18} />
              </Link>
              <Link to="/group" data-testid="hero-group-btn" className="border border-zinc-700 hover:border-[#CCFF00] hover:text-[#CCFF00] px-6 py-4 rounded-xl inline-flex items-center gap-2 uppercase tracking-wider font-semibold text-sm">
                Book & Save Together <Users size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight">Two ways to book</h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="card-surface card-hover p-8 group transition-all">
            <img src={CARD1} alt="" className="rounded-xl aspect-[16/9] object-cover w-full mb-6" />
            <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Individual</div>
            <h3 className="font-display text-3xl mt-2">Request a Detail</h3>
            <p className="text-zinc-400 mt-3">Pick a service, tell us about your vehicle, and we'll confirm your time.</p>
            <Link to="/book" data-testid="home-request-detail-btn" className="mt-6 inline-flex items-center gap-2 text-[#CCFF00] font-semibold uppercase tracking-wider text-sm">
              Start request <ArrowRight size={16} />
            </Link>
          </div>
          <div className="card-surface card-hover p-8 group transition-all">
            <img src={CARD2} alt="" className="rounded-xl aspect-[16/9] object-cover w-full mb-6" />
            <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Multi-vehicle</div>
            <h3 className="font-display text-3xl mt-2">Book & Save Together</h3>
            <p className="text-zinc-400 mt-3">Neighbors, coworkers, churches, apartment communities - get better rates when we service multiple cars in one location.</p>
            <Link to="/group" data-testid="home-book-group-btn" className="mt-6 inline-flex items-center gap-2 text-[#CCFF00] font-semibold uppercase tracking-wider text-sm">
              Send inquiry <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: Zap, title: "Fast & Mobile", desc: "We come to you. No trip to a shop." },
            { icon: ShieldCheck, title: "Premium Protection", desc: "Ceramic-grade products and pro-level care." },
            { icon: Users, title: "Community-First", desc: "Group bookings support our neighborhoods." },
          ].map((f, i) => (
            <div key={i} className="card-surface p-6">
              <f.icon className="text-[#CCFF00]" />
              <div className="font-display text-2xl mt-3">{f.title}</div>
              <div className="text-zinc-400 mt-2 text-sm">{f.desc}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
